module.exports = __webpack_public_path__ + "img/om.b9b7d0bc.svg";